// @ts-ignore
import { URIResolver, Brush2D, BrushPrototype, ShapeFactory, BrushGL, BlendMode } from "digital-ink"

/* **************************** VECTOR BRUSHES **************************** */

const triangle = new Brush2D("app://ink-samples/vector-brush/Triangle", ShapeFactory.createCircle(3), 1);
const rhombus = new Brush2D("app://ink-samples/vector-brush/Rhombus", ShapeFactory.createCircle(4), 1);

const circle = new Brush2D("app://ink-samples/vector-brush/Circle", [
	// type decl of BrushPrototye.create is broken
	BrushPrototype.create(BrushPrototype.Type.CIRCLE as any, 0, 4),
	BrushPrototype.create(BrushPrototype.Type.CIRCLE as any, 2, 8),
	BrushPrototype.create(BrushPrototype.Type.CIRCLE as any, 6, 16),
	BrushPrototype.create(BrushPrototype.Type.CIRCLE as any, 18, 32)
], 1);

/* **************************** RASTER BRUSHES **************************** */

const pencilBrush = new BrushGL("app://ink-samples/raster-brush/Pencil", "textures/shape.png", "textures/fill.png", { spacing: 0.15, scattering: 0.15 })

/* **************************** VECTOR TOOLS **************************** */

const pen = {
	name: "app://ink-samples/toolkit/Pen",
	brush: circle.name,

	dynamics: {
		size: {
			value: {
				min: 2.1,
				max: 4.2
			},

			velocity: {
				min: 100,
				max: 4000
			},

			pressure: {
				min: 0.2,
				max: 0.8
			}
		}
	},

	statics: {
		// alpha: 0.3
		red: 80,
		green: 80,
		blue: 80,
	}
};

/* **************************** RASTER TOOLS **************************** */

const pencilTool = {
	name: "app://ink-samples/toolkit/Pencil",
	brush: pencilBrush.name,

	dynamics: {
		size: {
			value: {
				min: 4,
				max: 12
			},

			velocity: {
				min: 100,
				max: 4000
			}
		},

		alpha: {
			value: {
				min: 0.1,
				max: 0.2
			},

			velocity: {
				min: 100,
				max: 4000
			}
		}
	}
};

/* **************************** ERASER TOOLS **************************** */

const eraserWholeStroke = {
	name: "app://ink-samples/toolkit/WholeStrokeEraser",
	brush: triangle.name,

	statics: {
		size: 10,
		red: 0,
		green: 0,
		blue: 0,
		alpha: 0
	}
};

const eraserPartialStroke = {
	name: "app://ink-samples/toolkit/PartialStrokeEraser",
	brush: rhombus.name,
	blendMode: BlendMode.DESTINATION_OUT,

	dynamics: {
		size: {
			value: {
				min: 16,
				max: 64
			},

			velocity: {
				min: 720,
				max: 3900
			}
		}
	},

	statics: {
		red: 255,
		green: 255,
		blue: 255,
		alpha: 1
	}
};

/* **************************** SELECTOR TOOLS **************************** */

const selectorTool = {
	name: "app://ink-samples/toolkit/Selector",
	brush: circle.name,

	statics: {
		size: 2,
		red: 0,
		green: 151,
		blue: 212,
		alpha: 1
	}
}

/* **************************** ************ **************************** */

let instance: DataRepository;

type URIResolver = any;

class DataRepository extends URIResolver {
	init() {
		this.register(circle.name, circle);
		this.register(triangle.name, triangle);
		this.register(rhombus.name, rhombus);
		this.register(pencilBrush.name, pencilBrush);

		this.register(pen.name, pen);
		this.register(pencilTool.name, pencilTool);

		this.register(eraserWholeStroke.name, eraserWholeStroke);
		this.register(eraserPartialStroke.name, eraserPartialStroke);

		this.register(selectorTool.name, selectorTool);
	}

	register(_a: any, _b: any) {
		super.register(_a, _b);
	}

	get(_a: any) {
		return super.get(_a);
	}

	getItems(Type: any) {
		return (this as any).items.filter((value: any) => value instanceof Type);
	}

	static {
		instance = new DataRepository();
	}
}

export default instance
